import type { FormFieldState } from "$lib/utils/formFieldState";

export type { FormFieldState };

const STATE_CLASS: Record<FormFieldState, string | false> = {
  default: false,
  filled: "surface-input-filled",
  empty: "surface-input-empty",
  invalid: "surface-input-invalid",
};

export function fieldStateClass(
  state: FormFieldState | undefined,
  fallback?: { invalid?: boolean; autofilled?: boolean },
): string | false {
  if (state && state !== "default") return STATE_CLASS[state];
  if (fallback?.invalid) return STATE_CLASS.invalid;
  if (fallback?.autofilled) return STATE_CLASS.filled;
  return false;
}

export function fieldStateFocusRing(state: FormFieldState | undefined, invalid?: boolean): string {
  const effective = state ?? (invalid ? "invalid" : "default");
  if (effective === "invalid") {
    return "focus:border-(--surface-danger) focus:ring-(--surface-danger)/30";
  }
  if (effective === "filled") {
    return "focus:border-(--color-success-600) focus:ring-(--color-success-500)/40";
  }
  if (effective === "empty") {
    return "focus:border-(--color-danger-500) focus:ring-(--color-danger-500)/20";
  }
  return "focus:border-(--surface-accent) focus:ring-(--surface-accent)/30";
}
